import React from 'react'
import MediaQuery from 'react-responsive'
import theme from '../styles/theme'

const Query = props => {
  return <MediaQuery maxWidth={theme.breakpoints[props.moreThan]} minWidth={theme.breakpoints[props.lessThan]}>{props.children}</MediaQuery>
}

export default Query
